<template>
  <div>
    <page-title title_text="تسویه‌ها" icon="settlements">
    </page-title>
    <div class="d-flex justify-content-between">
      <ul class="nav nav-tabs m-0 p-0">
        <!--      <li class="nav-item cp_pointer" @click="walletSettlement()">-->
        <!--        <a class="nav-link" :class="wallet_settlements ? 'active' : ''" aria-current="page">تسویه های کیف پول</a>-->
        <!--      </li>-->
        <!-- <li class="nav-item cp_pointer">
          <router-link class="nav-link" to="/settlements/psp-settlements">تسویه های مستقیم</router-link>
        </li> -->
        <li class="nav-item cp_pointer" @click="gatewaySettlement()">
          <a class="nav-link" :class="gateway_settlements ? 'active' : ''">تسویه های پرداختیاری</a>
        </li>
      </ul>
      <button
          class="btn btn-primary" v-if="gateway_settlements"
          type="button" style="border-radius: 10px;"
          data-toggle="modal"
          data-target="#settlement_excel_export"
      >
        خروجی اکسل
      </button>
    </div>
    <div class="modal fade" id="settlement_excel_export" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <div class="text-center">خروجی اکسل</div>
            <form id="settlement_excel_export_form" class="my-3 d-flex flex-column align-items-center">
              <div class="d-flex justify-content-between">
                <div class="form-group col-6">
                  <label for="from_date" class="col-form-label"
                  >
                    از تاریخ
                  </label>
                  <datePicker
                      format="YYYY-MM-DD"
                      display-format="dddd jDD jMMMM jYYYY"
                      input-class="form-control"
                      id="from_date"
                      name="from_date"
                      v-model="from_date"
                      type="date"
                  />
                  <ul v-if="errors.from_date.length" class="error-container">
                    <li v-for="(err, i) in errors.from_date" :key="i" class="text-danger">{{ err }}</li>
                  </ul>
                </div>
                <div class="form-group col-6">
                  <label for="to_date" class="col-form-label"
                  >
                    تا تاریخ
                  </label>
                  <datePicker
                      format="YYYY-MM-DD"
                      display-format="dddd jDD jMMMM jYYYY"
                      input-class="form-control"
                      id="to_date"
                      name="to_date"
                      v-model="to_date"
                      type="date"
                  />
                  <ul v-if="errors.to_date.length" class="error-container">
                    <li v-for="(err, i) in errors.to_date" :key="i" class="text-danger">{{ err }}</li>
                  </ul>
                </div>
              </div>
              <button
                  type="button"
                  @click="exportExcel"
                  id="settlement_excel_export_btn"
                  class="btn btn-success px-4 mt-3"
                  style="border-radius: 10px"
              >
                خروجی اکسل
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- Wallets Settlements Components -->
    <!--    <wallet-settlements v-if="wallet_settlements" :show_title="false"></wallet-settlements>-->

    <div id="gateway-settlements" v-if="gateway_settlements">
      <div class="bg-white shadow-sm p-3 my-3" style="border-radius: 10px;">
        <div class="row">
          <div class="col-sm my-2">
            <div class="form-group my-0">
              <input class="form-control  px-3 rounded-pill" placeholder="شناسه تسویه" type="text" v-model="filter_settlement_id">
            </div>
          </div>
          <div class="col-sm my-2">
            <div class="form-group my-0">
              <select class="form-control kt-selectpicker text-secondary" v-model="filter_status" id="filter_status">
                <option :value="null" selected disabled>وضعیت</option>
                <option value="PENDING">{{ $t('settlement.status.pending') }}</option>
                <option :value="2">{{ $t('settlement.status.accepted') }}</option>
                <option :value="3">{{ $t('settlement.status.rejected') }}</option>
              </select>
            </div>
          </div>
          <div class="col-sm my-2">
            <div class="form-group my-0">
              <input class="form-control px-3 rounded-pill" placeholder="مبلغ" type="number" v-model="filter_price">
            </div>
          </div>
          <div class="col-sm my-2">
            <div class="form-group my-0">
              <select
                  class="form-control"
                  v-model=filter_gateway
                  name = "filter_gateway"
                  id="filter_gateway"
              >
                <option :value="null" selected disabled>{{ $t('label.gateway') }}</option>
                <option
                    :key="index"
                    v-for="(data, index) in shop_data_gateway"
                    :value = data
                >
                  {{ data.title+"  -  "+getShopType(data.shop_type)+"  -  "+data.sequence}}
                </option>
              </select>
            </div>
          </div>
          <div class="col-sm my-2">
            <div>
              <button :class="query ? 'btn btn-success mr-2' : 'btn btn-success btn-block'" style="border-radius: 10px;"
                      @click="get_data(settlements.first_page_url)">اعمال فیلتر
              </button>
              <button class="btn btn-danger mr-3" style="border-radius: 10px;"
                      @click="reset_and_get" v-if="query">حذف فیلتر
              </button>
            </div>
          </div>
        </div>
      </div>

      <div v-if="is_init" class="bg-white shadow-sm py-3 my-2 overlay overlay-block" style="border-radius: 10px;" >

        <div class="px-3">
          <!-- Mobile: card rows (same style as dashboard recent-settlements) -->
          <div class="d-md-none">
            <template v-if="settlements.data.length > 0">
              <div
                  class="settlement-mobile-card"
                  v-for="(settlement, index) in settlements.data"
                  :key="'m' + index"
              >
                <router-link
                    class="text-reset text-decoration-none"
                    :to="'/settlements/' + settlement.id + '/details'"
                >
                  <div class="d-flex justify-content-between align-items-center mb-2">
                    <span class="settlement-id en_num">{{ settlement.id }}</span>
                    <span :class="'label label-inline' + ' label-light-' + statusVariantForCommonAccess(settlement.status)">
                      {{ statusStrForCommonAccess.get(settlement.status) }}
                    </span>
                  </div>
                  <div class="d-flex justify-content-between align-items-center mb-2">
                    <span class="settlement-price en_num">{{ settlement.amount }} <small class="text-muted">ریال</small></span>
                    <span class="settlement-meta" v-text="toPersianDateFormat(settlement.created_at)"></span>
                  </div>
                  <div class="d-flex justify-content-between align-items-center settlement-meta">
                    <span class="en_num" dir="ltr">{{ settlement.bank_reference || '-' }}</span>
                    <span>
                      <img v-if="pspLogo(settlement.psp)" :src="pspLogo(settlement.psp)" alt="psp" width="24" height="24">
                      <span v-else>-</span>
                    </span>
                  </div>
                </router-link>
              </div>
            </template>
            <div class="text-center py-5" v-if="settlements.data.length == 0">
              <img src="@/assets/new/image/not-found_new.png" width="160" />
            </div>
          </div>

          <!-- Desktop: table as before -->
          <div class="d-none d-md-block table-responsive">
            <table class="table  table-responsive table-borderless text-center" v-if="settlements.data.length > 0">
              <thead>
              <tr>
                <th scope="col" style="background-color: #eee; border-radius: 0 16px 16px 0;">شناسه تسویه</th>
                <th scope="col" style="background-color: #eee; cursor: pointer;" @click="sortBy('amount')">
                  <span class="mx-2">مبلغ (ریال)</span>
                  <span v-if="sort_field == 'amount'">
                  <span v-if="sort_sort == 'asc'">
                    <svg xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 24 24" width="16" fill="#00bea5"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M13 19V7.83l4.88 4.88c.39.39 1.03.39 1.42 0 .39-.39.39-1.02 0-1.41l-6.59-6.59c-.39-.39-1.02-.39-1.41 0l-6.6 6.58c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L11 7.83V19c0 .55.45 1 1 1s1-.45 1-1z"/></svg>
                  </span>
                  <span v-else>
                    <svg xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 24 24" width="16" fill="#00bea5"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M11 5v11.17l-4.88-4.88c-.39-.39-1.03-.39-1.42 0-.39.39-.39 1.02 0 1.41l6.59 6.59c.39.39 1.02.39 1.41 0l6.59-6.59c.39-.39.39-1.02 0-1.41-.39-.39-1.02-.39-1.41 0L13 16.17V5c0-.55-.45-1-1-1s-1 .45-1 1z"/></svg>
                  </span>
                </span>
                </th>
                <th scope="col" style="background-color: #eee; cursor: pointer;" @click="sortBy('created_at')">
                  <span class="mx-2">تاریخ درخواست</span>
                  <span v-if="sort_field == 'created_at'">
                  <span v-if="sort_sort == 'asc'">
                    <svg xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 24 24" width="16" fill="#00bea5"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M13 19V7.83l4.88 4.88c.39.39 1.03.39 1.42 0 .39-.39.39-1.02 0-1.41l-6.59-6.59c-.39-.39-1.02-.39-1.41 0l-6.6 6.58c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L11 7.83V19c0 .55.45 1 1 1s1-.45 1-1z"/></svg>
                  </span>
                  <span v-else>
                    <svg xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 24 24" width="16" fill="#00bea5"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M11 5v11.17l-4.88-4.88c-.39-.39-1.03-.39-1.42 0-.39.39-.39 1.02 0 1.41l6.59 6.59c.39.39 1.02.39 1.41 0l6.59-6.59c.39-.39.39-1.02 0-1.41-.39-.39-1.02-.39-1.41 0L13 16.17V5c0-.55-.45-1-1-1s-1 .45-1 1z"/></svg>
                  </span>
                </span>
                </th>
                <th scope="col" style="background-color: #eee;">شناسه ارجاع بانکی</th>
                <th scope="col" style="background-color: #eee;">پی اس پی</th>
                <th scope="col" style="background-color: #eee;">تاریخ پرداخت</th>
                <th scope="col" style="background-color: #eee; cursor: pointer;" @click="sortBy('status')">
                  <span class="mx-2">وضعیت</span>
                  <span v-if="sort_field == 'status'">
                  <span v-if="sort_sort == 'asc'">
                    <svg xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 24 24" width="16" fill="#00bea5"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M13 19V7.83l4.88 4.88c.39.39 1.03.39 1.42 0 .39-.39.39-1.02 0-1.41l-6.59-6.59c-.39-.39-1.02-.39-1.41 0l-6.6 6.58c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L11 7.83V19c0 .55.45 1 1 1s1-.45 1-1z"/></svg>
                  </span>
                  <span v-else>
                    <svg xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 24 24" width="16" fill="#00bea5"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M11 5v11.17l-4.88-4.88c-.39-.39-1.03-.39-1.42 0-.39.39-.39 1.02 0 1.41l6.59 6.59c.39.39 1.02.39 1.41 0l6.59-6.59c.39-.39.39-1.02 0-1.41-.39-.39-1.02-.39-1.41 0L13 16.17V5c0-.55-.45-1-1-1s-1 .45-1 1z"/></svg>
                  </span>
                </span>
                </th>
                <th scope="col" style="background-color: #eee; border-radius:16px 0 0 16px ;">جزییات</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(settlement, index) in settlements.data" :key="index">
                <td class="en_num">{{ settlement.id }}</td>
                <td>{{ settlement.amount }}</td>
                <td v-text="toPersianDateFormat(settlement.created_at)"></td>
                <td>{{ settlement.bank_reference }}</td>
                <td>
                  <div v-if="settlement.psp == 'mellat'">
                    <img src="/assets/media/psp/mellat.png" width="32" height="32">
                  </div>
                  <div v-else-if="settlement.psp == 'parsian'">
                    <img src="/assets/media/psp/parsian.svg" width="32" height="32">
                  </div>
                  <div v-else-if="settlement.psp == 'pasargad'">
                    <img src="/assets/media/psp/pasargad.svg" width="32" height="32">
                  </div>
                  <div v-else-if="settlement.psp == 'saman'">
                    <img src="/assets/media/psp/saman.svg" width="32" height="32">
                  </div>
                  <div v-else-if="settlement.psp == 'novin'">
                    <img src="/assets/media/psp/novin.svg" width="32" height="32">
                  </div>
                  <div v-else-if="settlement.psp == 'sepehr'">
                    <img src="/assets/media/psp/sepehr.png" width="32" height="32">
                  </div>
                  <div v-else-if="settlement.psp == 'irankish'">
                    <img src="/assets/media/psp/irankish.png" width="32" height="32">
                  </div>
                  <div v-else-if="settlement.psp == 'asanpardakht'">
                    <img src="/assets/media/psp/ap-logo.png" width="32" height="32">
                  </div>
                  <div v-else v-text="`_____`" style="color:#333;"></div>
                </td>
                <td v-text="settlement.payment_date"></td>
                <td>
              <span :class="'label label-inline' + ' label-light-' + statusVariantForCommonAccess(settlement.status)">
                  {{statusStrForCommonAccess.get(settlement.status)}}
              </span>
                </td>
                <td>
                  <router-link :to="'/settlements/'+ settlement.id +'/details'">
                    <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24" width="20" fill="#bbb">
                      <path d="M0 0h24v24H0V0z" fill="none"/>
                      <path d="M12 4C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 12.5c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>
                    </svg>
                  </router-link>
                </td>
              </tr>
              </tbody>
            </table>
            <div class="empty-table" style="height: 300px" v-else>
              <table class="table table-responsive table-borderless text-center">
                <thead>
                <tr>
                  <th scope="col" style="background-color: #eee; border-radius: 0 16px 16px 0;">شناسه تسویه</th>
                  <th scope="col" style="background-color: #eee;">مبلغ (ریال)</th>
                  <th scope="col" style="background-color: #eee;">تاریخ درخواست</th>
                  <th scope="col" style="background-color: #eee;">شناسه ارجاع بانکی</th>
                  <th scope="col" style="background-color: #eee;">تاریخ پرداخت</th>
                  <th scope="col" style="background-color: #eee;">وضعیت</th>
                  <th scope="col" style="background-color: #eee; border-radius:16px 0 0 16px ;">جزییات</th>
                </tr>
                </thead>
              </table>
              <div style="margin: 0 auto;">

                <img src="@/assets/new/image/not-found_new.png" width="200">
              </div>
            </div>
          </div>
        </div>

        <hr v-if="settlements.next_page_url || settlements.prev_page_url">

        <pagination :data="settlements" :get_data="get_data" :perpage="perpage"></pagination>


      </div>

      <div id="overlay" v-if="status == 'loading'">
        <div class="p-3" style="position: absolute;
  top: 50%;
  left: 50%;
  color: gray;
  background-color: white;
">


          <div class="spinner-border text-success" role="status">
          </div>
          <span>
          لطفا صبر کنید
        </span>


        </div>

      </div>
    </div>

  </div>
</template>

<script>
import $ from 'jquery';
import {i18n} from "@/plugins/i18n";
import { ApiService, ApiUrl } from '@/common/api.service';
import {statusStrForCommonAccess, statusVariantForCommonAccess} from "@/constants/settlementStatus";
import Pagination from "@/components/main/pagination";
import PageTitle from "@/components/main/components/pageTitle";
import {mapGetters} from "vuex";
import  { AllShopTypes } from "@/constants/AllShopTypes";
import walletSettlements from '@/pages/wallets/AyandeWallets/components/settlement-list-component';
import { KTApp } from '@/plugins/core/app';
import axios from "axios";

import toastr from "toastr";

export default {
  components: {PageTitle, Pagination,walletSettlements},
  data() {
    return {
      perpage: {
        value: 15,
      },
      is_init: false,
      status: 'loading',
      settlements: null,
      filter_settlement_id: '',
      filter_price: '',
      filter_status: null,
      sort_field: null,
      sort_sort: 'desc',
      statusVariantForCommonAccess,
      statusStrForCommonAccess,
      filter_gateway: null,
      gateway_settlements: true,
      wallet_settlements: false,
      from_date: null,
      to_date: null,
      errors: {
        from_date: [],
        to_date: [],
      }
    }
  },
  props : ['changeStatus'],
  computed: {
    ...mapGetters('gateway', [
      'shop_data_gateway',
      'shop_data_gateway_status'
    ]),
    toastr() {
      toastr.options = {
        closeButton: true,
        positionClass: "toast-bottom-center",
        preventDuplicates: false,
        rtl: false
      }

      return toastr
    },
    query() {
      let res = '';
      if (this.filter_gateway != null) {
        res = res + '&query[shop_id]=' + this.filter_gateway.shop_id;
      }
      if (this.filter_gateway !=null) {
        res = res + '&query[shop_type]=' + this.filter_gateway.shop_type;
      }
      if (this.filter_settlement_id != '') {
        res = res + '&query[settlement_id]=' + this.filter_settlement_id;
      }
      if (this.filter_price != '') {
        res = res + '&query[amount]=' + this.filter_price;
      }

      if (this.filter_status != null) {
        res = res + '&query[status]=' + this.filter_status;
      }

      if (this.sort_field != null) {
        res = res + '&sort[field]=' + this.sort_field + '&sort[sort]=' + this.sort_sort;
      }

      return res;
    }
  },
  methods: {
    pspLogo(psp) {
      const logos = {
        mellat: '/assets/media/psp/mellat.png',
        parsian: '/assets/media/psp/parsian.svg',
        pasargad: '/assets/media/psp/pasargad.svg',
        saman: '/assets/media/psp/saman.svg',
        novin: '/assets/media/psp/novin.svg',
        sepehr: '/assets/media/psp/sepehr.png',
        irankish: '/assets/media/psp/irankish.png',
        asanpardakht: '/assets/media/psp/ap-logo.png'
      };
      return logos[psp] || null;
    },
    getShopType(shop_type) {
      if (shop_type == AllShopTypes.PAYMENT_HELPER) {
        return  i18n.t('label.payment_helper')
      }
      if (shop_type == AllShopTypes.PAYMAN) {
        return  i18n.t('label.payman')
      }
      if (shop_type == AllShopTypes.IVR) {
        return  i18n.t('label.ivr')
      }
      if (shop_type == AllShopTypes.DEDICATED) {
        return  i18n.t('label.dedicated')
      }
    },
    exportExcel() {
      let form = $('#settlement_excel_export_form')
      let btn = $('#settlement_excel_export_btn')
      form.validate({
        rules: {
          from_date: {
            required: true,
          },
          to_date: {
            required: true,
          }
        }
      })

      if(!form.valid()) {
        return
      }

      KTApp.progress(btn)

      axios({
        url: ApiUrl.path('settlement/settlements-excel-export'),
        method: 'GET',
        params: { from_date: this.from_date, to_date: this.to_date },
        responseType: 'blob',
      })
          .then((response) => {
            let fileURL = window.URL.createObjectURL(new Blob([response.data]));
            let fileLink = document.createElement("a");
            fileLink.href = fileURL;
            fileLink.setAttribute("download", `settlements-${this.from_date}-${this.to_date}.xlsx`);
            document.body.appendChild(fileLink);

            fileLink.click();
            $('#settlement_excel_export').modal('hide')
            this.from_date = null
            this.to_date = null
          })
          .catch((error) => {
            const response = error.response;

            this.errors = { from_date: [], to_date: [] };

            if (response && response.data instanceof Blob) {
              const reader = new FileReader();

              reader.onload = () => {
                try {
                  const data = JSON.parse(reader.result);

                  this.toastr.error(data.message || 'خطای اعتبارسنجی');

                  if (data.data) {
                    this.errors.from_date = data.data.from_date || [];
                    this.errors.to_date   = data.data.to_date || [];
                  }

                } catch (e) {
                  this.toastr.error('خطای نامشخص در دریافت فایل');
                }
              };

              reader.readAsText(response.data);
            } else {
              this.toastr.error(
                  response && response.data && response.data.message
                      ? response.data.message
                      : 'خطای نامشخص'
              );
            }
          })
          .finally(() => {
            KTApp.unprogress(btn)
          })

    },
    toPersianDateFormat(val) {
      if (val == undefined || val == null || val == '') {
        return '';
      }

      val = String(val);

      return val.replace(/\-/g, "/");
    },
    sortBy(field) {
      this.sort_field = String(field);

      if (this.sort_sort == 'desc') {
        this.sort_sort = 'asc';
      } else {
        this.sort_sort = 'desc';
      }

      this.get_data(this.settlements.path + '?page=1');
    },
    resetQuery() {
      this.filter_settlement_id = '';
      this.filter_price = '';

      this.filter_status = null;
      $('[data-id="filter_status"] .filter-option-inner-inner').text('وضعیت');
    },
    get_data(url, callback = () => {}) {
      this.status = 'loading';
      ApiService.query(url + this.query + '&perpage=' + this.perpage.value)
          .then(json => {
            this.settlements = json.data.data;
            this.status = 'ok';
            callback();
          })
    },
    reset_and_get() {
      this.resetQuery();
      this.get_data(this.settlements.path + '?page=1');
    },
    gatewaySettlement(){
      this.gateway_settlements = true;
      this.wallet_settlements = false;
    },
    walletSettlement(){
      this.gateway_settlements = false;
      this.wallet_settlements = true;
    }
  },
  mounted() {
    this.$store.dispatch('gateway/fetchShopData');

    ApiService.get('settlement', '').then(json => {
      this.settlements = json.data.data;
      this.is_init = true;
      this.changeStatus('ok');
      this.status = 'ok';

      setTimeout(() => {
        $('.kt-selectpicker').selectpicker({
          size: 4,
          liveSearch: true,
          noneResultsText: i18n.t('selectpicker.none_result'),
          selectAllText: i18n.t('selectpicker.select_all'),
          noneSelectedText: i18n.t('selectpicker.nothing_selected')
        })
      }, 1000);
    })

    $('#settlement_excel_export').on('shown.bs.modal', () => {
      this.errors = {
        from_date: [],
        to_date: []
      };
    });
  }
}
</script>

<style scoped>
.error-container{
  padding: 10px 20px 0 10px;
}
.cp_pointer{
  cursor: pointer;
}
/* Mobile card rows — same visual language as dashboard recent-settlements */
.settlement-mobile-card {
  background: #fff;
  border: 1px solid rgba(0, 190, 165, .28);
  border-radius: 14px;
  padding: 12px 14px;
  margin-bottom: 10px;
  box-shadow: 0 0 5px rgba(140, 227, 214, .45);
}
.settlement-mobile-card a {
  display: block;
}
.settlement-id {
  font-size: 13px;
  color: rgba(18, 44, 52, .7);
}
.settlement-price {
  font-size: 14px;
  font-weight: 700;
  color: rgba(18, 44, 52, 1);
  white-space: nowrap;
}
.settlement-meta {
  font-size: 12px;
  color: rgba(18, 44, 52, .7);
}
.settlement-mobile-card .label {
  font-size: 11px;
}
@media screen and (max-width: 678px){
  .sm-settlements-header div {
    display: block !important;
    margin: 0.4rem 0;
  }
  .sm-wallets-margin{
    margin: 0 2.5rem 0 0;
  }
}
</style>